// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { VpnRequestDto } from '@ellf/common-dto';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';
import { map } from 'rxjs';

@Injectable()
export class VpnRequestApiClient extends BaseCRUDApiClient<VpnRequestDto> {
  baseUrl = this.config.apiEndpoint + '/vpn-request';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }

  downloadVpnRequestFromPretesting(testingId: string) {
    return this.http
      .post(
        `${this.baseUrl}/download-vpn-request-from-pre-testing`,
        {
          testingId: testingId,
        },
        {
          responseType: 'arraybuffer',
        },
      )
      .pipe(
        map((file: ArrayBuffer) => {
          return file;
        }),
      );
  }

  createVpnRequest(id: string) {
    return this.http
      .post(
        `${this.baseUrl}/create-vpn-request`,
        {
          id: id,
        },
        {
          responseType: 'arraybuffer',
        },
      )
      .pipe(
        map((file: ArrayBuffer) => {
          return file;
        }),
      );
  }

  saveVpnRequest(id: string) {
    return this.http.post(`${this.baseUrl}/save-vpn-request`, {
      id: id,
    });
  }
}
